/**
 * 判断股票是否是etf
 * @param {object} stock
 * @param {string} stock.symbol 股票代吗
 * @returns {boolean}
 */
export default function stockIsEtf(stock) {
  const ETF_SYMBOL_PREFIX = ['15', '16', '18', '50', '51', '52']
  if (stock.symbol) {
    return ETF_SYMBOL_PREFIX.indexOf(stock.symbol.substr(0, 2)) > -1
  }
  return false
}
